import { type FormSchemaMapper } from './mappers/form-schema-mapper';
import { type Form } from '@wix/ambassador-forms-v4-form/types';
import Ajv from 'ajv';
import { asRequired } from '../utils/lang';
import addFormats from 'ajv-formats';
import { addCustomFormats } from './ajv/ajv-custom-formats';
import { addCustomKeywords } from './ajv/ajv-custom-keywords';

import addErrors from 'ajv-errors';
import uniqueItemPropertiesKeyword from 'ajv-keywords/dist/keywords/uniqueItemProperties';

export function createAjvSchemaValidatorFactory(
  formSchemaMapper: FormSchemaMapper,
  libraryBasedPhoneFieldValidationEnabled: boolean,
  lenientPhoneValidation: boolean,
) {
  return function createAjvSchemaValidator(formsSchemas: Form[]) {
    const ajv: Ajv = new Ajv({ allErrors: true, multipleOfPrecision: 8 });
    addFormats(ajv);
    addCustomFormats(ajv, libraryBasedPhoneFieldValidationEnabled);
    addCustomKeywords(
      ajv,
      libraryBasedPhoneFieldValidationEnabled,
      lenientPhoneValidation,
    );
    addErrors(ajv);
    uniqueItemPropertiesKeyword(ajv);
    formsSchemas.forEach((formSchema) => {
      const validate = ajv.getSchema(
        asRequired(formSchema.id, formSchema, 'id'),
      );
      if (!validate) {
        const formAjvSchema = formSchemaMapper(formSchema);
        formAjvSchema && ajv.addSchema(formAjvSchema);
      }
    });
    return ajv;
  };
}
